import { useTranslation } from "react-i18next";
import { usePremium } from "../auth/is_loggedin";
import LinkButton from "../link-button/link-button";
import FakeButton from "@/components/fake-button";

const Supporter: React.FC = () => {
  const premium = usePremium();
  const { t } = useTranslation("main");

  return !premium ? (
    <LinkButton path={"/supporter"} size={"lg"}>
      {t("profile.body.supporterPurchase")}
    </LinkButton>
  ) : (
    <FakeButton size="xl" className="p-1">
      {t("profile.body.supporterThanks")}
    </FakeButton>
  );
};

export default Supporter;
